module.exports = __webpack_public_path__ + "img/group.696c360f.svg";